import moment from "moment";
import React from "react";

import {LIGHT_TEXT_COLOR} from "../styles";

const PrettyDate = (props) => {
    const formattedDate = moment(props.date).format("MMM D, YYYY");
    const formattedTime = moment(props.date).format("h:mma");
    return props.timeOnSameLine
        ? <span className={`x-pretty-date ${props.className}`}>{formattedDate}&nbsp;{formattedTime}</span>
        : <div className={`x-pretty-date ${props.className}`} style={{color: LIGHT_TEXT_COLOR, textAlign: "right"}}>
              {formattedDate}<br/>{formattedTime}
          </div>;
};

PrettyDate.propTypes = {
    className: React.PropTypes.string,
    timeOnSameLine: React.PropTypes.bool,
    date: React.PropTypes.string
};

export default PrettyDate;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/PrettyDate.js
 **/